module.exports = __webpack_public_path__ + "static/media/viewIcon.14890851.png";